export default "__VITE_PUBLIC_ASSET__aad95f9a__"